import { createContext, useContext, type ContextType, type FC, type ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    buyerHost: string;
    isMobile: boolean;
    isTablet?: boolean;
    isMWSearchBarRedesignVariant?: boolean;
};

const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
    buyerHost: '',
    isMWSearchBarRedesignVariant: false,
});

type HeaderFooterServerVars = ContextType<typeof HeaderFooterServerVarsContext>;

export function useHeaderFooterServerVars(): HeaderFooterServerVars {
    return useContext(HeaderFooterServerVarsContext);
}

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
    buyerHost: string;
    isMWSearchBarRedesignVariant?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    buyerHost,
    isMobile,
    isTablet,
    isMWSearchBarRedesignVariant,
}) => (
    <HeaderFooterServerVarsContext
        value={{ buyerHost, isMobile, isTablet, isMWSearchBarRedesignVariant }}
    >
        {children}
    </HeaderFooterServerVarsContext>
);
